module.exports = __webpack_public_path__ + "static/media/440508655_1001662901304598_1903461448505078554_n (1).413b4b73.jpg";